module.exports = __webpack_public_path__ + "img/bg_rocket_launch_1.14f58a55.png";